import React from "react";

import { Button, Illustration, Modal, Text } from "@orgmym/leeloo-core";
import { useTranslation } from "react-i18next";

import * as styles from "./leave-private-media-confirmation.css";

interface LeavePrivateMediaConfirmationProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Warns the creator that an in-progress media proposition will be lost. Shared
 * between leaving a conversation (ChatLayout) and replacing the media panel
 * with the user-info panel (ChatConversationLayout).
 */
export const LeavePrivateMediaConfirmation: React.FC<
  LeavePrivateMediaConfirmationProps
> = ({ isOpen, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <Modal
      hideModal={onCancel}
      ariaHideApp={false}
      buttons={[
        <Button key="leave" onPress={onConfirm} variant="destructive">
          {t("creators_chat_leave_private_media_confirm")}
        </Button>,
        <Button key="stay" onPress={onCancel} variant="tertiary">
          {t("creators_chat_leave_private_media_cancel")}
        </Button>
      ]}
    >
      <Illustration name="warning" className={styles.illustration} />
      <Text weight="medium" className={styles.title}>
        {t("creators_chat_leave_private_media_title")}
      </Text>
      <Text className={styles.description}>
        {t("creators_chat_leave_private_media_description")}
      </Text>
    </Modal>
  );
};
